module.exports = __webpack_public_path__ + "df3dfa611a9748b0b143fb79c4ef8bf5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-lake.png
// module id = 3640
// module chunks = 0